import jwtDecode from 'jwt-decode'
import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'
import React from 'react'
import { bffService } from '../utils/axios'

/**
 * @typedef {Object} UserProps
 * @property {string} email
 * @property {boolean} email_verified
 * @property {string} name
 * @property {string} preferred_username
 */

/**
 * @type {React.Context<{user?: import("keycloak-js").KeycloakTokenParsed & UserProps, operator?: Object}>}
 */
const Context = createContext()

const UserProvider = ({ children }) => {
  const { token, isAuthenticated } = useAuth()
  const [user, setUser] = useState(null)
  const [operator, setOperator] = useState(null)

  useEffect(() => {
    if (token && isAuthenticated) {
      const payload = jwtDecode(token)
      setUser(payload)
    } else {
      setUser(null)
      setOperator(null)
    }
  }, [isAuthenticated, token])

  // Fetch operator data when user is authenticated
  useEffect(() => {
    if (token && isAuthenticated) {
      bffService
        .get('/company')
        .then((response) => {
          setOperator(response.data)
        })
        .catch((error) => {
          console.error('Error fetching operator:', error)
          setOperator(null)
        })
    }
  }, [token, isAuthenticated])

  return (
    <Context.Provider value={{ user, operator }}>{children}</Context.Provider>
  )
}

export const useUser = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error(`useUser() was called outside a UserProvider`)
  }

  return context
}
export default UserProvider
